import React from 'react'
import { createRoot } from 'react-dom/client'

import { createInertiaApp } from '@inertiajs/react'
import { ThemeProvider } from '@material-tailwind/react'

import * as Sentry from '@sentry/browser'

import 'react-toastify/dist/ReactToastify.css'

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props }) {
    createRoot(el).render(
      <ThemeProvider>
        <App {...props} />
      </ThemeProvider>
    )
  }
})
